import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './Login.scss';
import config from '../../config.json';
import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import ForgotPwdCard from './ForgotPwdCard';
import { useAuth } from './AuthProvider';
import axios from 'axios';
import { useNotification } from '../../Helper/NotificationProvider';
import { URL_FORGOT } from '../../service/endpoints';
import { getBlobUrl } from '../../Helper/helperFunctions';

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const { login } = useAuth();
  const { openNotification, contextHolder } = useNotification();
  const [logoUrl, setLogoUrl] = useState(config.logo);

  // Fetch fresh logo URL on mount
  useEffect(() => {
    const fetchLogoUrl = async () => {
      if (config.login.imageBlobId) {
        const url = await getBlobUrl(config.login.imageBlobId);
        if (url) setLogoUrl(url);
      }
    };
    fetchLogoUrl();
  }, []);

  const handleClose = () => {
    navigate('/login');
  };

  const onFinish = values => {
    postForgotPwd(values.email);
  };

  const postForgotPwd = async email => {
    try {
      if (email !== '') {
        const authBody = {
          email: email
        };

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: URL_FORGOT,
          headers: {
            'Content-Type': 'application/json'
          },
          data: authBody
        };

        const response = await axios.request(config)

        const { userId, permissionLevel, accessToken, refreshToken } = response.data;
        login(userId, permissionLevel, accessToken, refreshToken);
        navigate('/login');
        openNotification(
          'bottomRight',
          'Erfolg',
          'Email wurde erfolgreich an angegebene Adresse geschickt.',
          true
        );
      }
    } catch (err) {
      openNotification(
        'bottomRight',
        t('Anmeldung fehlgeschlagen!'),
        t('Überprüfen Sie die Anmeldedaten.'),
        false
      );
      console.log(err);
    }
  };

  return (
    <div className="container">
      {contextHolder}
      <header className="app-header">
        <img src={logoUrl} alt="Logo" />
        {!config.resetPw.active && (
          <div className="close-btn">
            <Button
              shape="circle"
              type="primary"
              onClick={handleClose}
              icon={<CloseOutlined />}
              size={'large'}
              className="close-login-btn"
            />
          </div>
        )}
      </header>
      <div className="card-login">
        <p className="title">{t('Passwort vergessen?')}</p>
        <ForgotPwdCard
          translation={t}
          setLanguage={setLanguage}
          onFinish={onFinish}
          language={language}
        />
      </div>
      {/*<BaseFooter />*/}
    </div>
  );
}
